module.exports = __webpack_public_path__ + "static/media/Kain.cc59d461.png";